import { baseBackendUrl } from "../shared/constants";

export async function fetchContacts(token) {
    try {
        const response = await fetch(`${baseBackendUrl}/contacts`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (!response.ok) {
            throw new Error("Ошибка при загрузке данных");
        }
        const data = await response.json();
        // return data;
        return Array.isArray(data) ? data : data.contacts ?? [];
    } catch (error) {
        console.error("Ошибка при загрузке контактов:", error);
        return [];
    }
}

export async function saveContent(values, currentContact, token) {
    try {
        const method = currentContact ? "PUT" : "POST";
        const url = currentContact
            ? `${baseBackendUrl}/contacts/${currentContact.id}`
            : `${baseBackendUrl}/contacts`;
        const response = await fetch(url, {
            method,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(values),
        });
        if (!response.ok) throw new Error("Ошибка сохранения контакта");
    } catch (error) {
        console.error(error);
    }
}

export async function deleteContact(id, token) {
    await fetch(`${baseBackendUrl}/contacts/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
    });
}